export default "__VITE_ASSET__0e0140f4__"